// extracted by mini-css-extract-plugin
export var option = "_4m-1";
export var optionActive = "_4m-2";
export var pill = "_4m-0";